import * as React from "react";

const IconArrow = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="9"
    fill="none"
    viewBox="0 0 15 9"
    style={{ cursor: "pointer" }}
    {...props}
  >
    <path
      fill="var(--color-01)"
      d="M14.306.187A.62.62 0 0 0 13.894 0c-.156 0-1.248 1.05-3.443 3.347L7.242 6.706 4.033 3.347C1.838 1.05.746 0 .591 0 .334 0 0 .28 0 .501c0 .21 7.053 7.546 7.242 7.546.2 0 7.242-7.336 7.242-7.546 0-.07-.078-.221-.178-.314"
    ></path>
  </svg>
);

export default IconArrow;
